import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/node_modules/@mui/material/esm/Link/Link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/apps/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/legal/LegalDocumentPaper.tsx");
